const initialState = () => ({
  id: null,
  name: null
})

export default {
  namespaced: true,
  state: initialState(),
  mutations: {
    assign (state, { id, name }) {
      state.id = id
      state.name = name
    }
  }
}
